import { render, staticRenderFns } from "./GatewayReportWithoutTransaction.vue?vue&type=template&id=025994b6"
import script from "./GatewayReportWithoutTransaction.vue?vue&type=script&lang=js"
export * from "./GatewayReportWithoutTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports